"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.invalidArrayLength = exports.nonExistingItem = exports.unsupportedPropertyMessageWithHint = exports.invalidItemLink = exports.invalidOptionFields = exports.invalidObjectFormatWithCustomMessage = exports.invalidFormatMessageWithHint = exports.onlyGetter = exports.invalidOption = exports.invalidMenuItemMessage = exports.invalidSvgValue = exports.unsupportedFunctionForType = exports.invalidTargetWithIndex = exports.unsupportedLinkType = exports.invalidFileTypeForFileLimit = exports.invalidImageInGalleryWithIndex = exports.invalidStateInputMessage = exports.invalidSlideInputMessage = exports.noneImageInGallery = exports.patternMismatchMessage = exports.invalidEnumValueMessage = exports.invalidTypeMessage = exports.invalidNumberBoundsMessage = exports.invalidStringLengthMessage = exports.missingFieldMessage = exports.nilAssignmentMessage = void 0;
const assert_1 = require("../assert");
const messageTemplates_1 = require("./messageTemplates");
const nilAssignmentMessage = ({ compName, functionName, propertyName, index }) => {
    if (assert_1.assert.isNumber(index)) {
        return messageTemplates_1.templates.warning_not_null_with_index({
            propertyName,
            functionName,
            index,
        });
    }
    if (compName) {
        return messageTemplates_1.templates.warning_not_null_for_comp_name({
            compName,
            functionName,
            propertyName,
        });
    }
    return messageTemplates_1.templates.warning_not_null({ functionName, propertyName });
};
exports.nilAssignmentMessage = nilAssignmentMessage;
const missingFieldMessage = ({ functionName, propertyName, index, }) => {
    return assert_1.assert.isNumber(index)
        ? messageTemplates_1.templates.error_mandatory_val_with_index({
            functionName,
            propertyName,
            index,
        })
        : messageTemplates_1.templates.error_mandatory_val({ functionName, propertyName });
};
exports.missingFieldMessage = missingFieldMessage;
const invalidStringLengthMessage = ({ functionName, propertyName, value, maximum, minimum, index }) => {
    if (minimum && maximum) {
        if (minimum === maximum) {
            return assert_1.assert.isNumber(index)
                ? messageTemplates_1.templates.error_length_accept_single_value_with_index({
                    functionName,
                    propertyName,
                    value,
                    expectedValue: minimum,
                    index,
                })
                : messageTemplates_1.templates.error_length_accept_single_value({
                    functionName,
                    propertyName,
                    value,
                    expectedValue: minimum,
                });
        }
        return assert_1.assert.isNumber(index)
            ? messageTemplates_1.templates.error_length_in_range_with_index({
                functionName,
                propertyName,
                value,
                maximum,
                minimum,
                index,
            })
            : messageTemplates_1.templates.error_length_in_range({
                functionName,
                propertyName,
                value,
                maximum,
                minimum,
            });
    }
    if (!minimum && maximum) {
        return assert_1.assert.isNumber(index)
            ? messageTemplates_1.templates.error_length_exceeds_with_index({
                functionName,
                propertyName,
                value,
                maximum,
                index,
            })
            : messageTemplates_1.templates.error_length_exceeds({
                functionName,
                propertyName,
                value,
                maximum,
            });
    }
    // valided minimum length
    return assert_1.assert.isNumber(index)
        ? messageTemplates_1.templates.error_length_less_than_with_index({
            functionName,
            propertyName,
            value,
            minimum: minimum,
            index,
        })
        : messageTemplates_1.templates.error_length_less_than({
            functionName,
            propertyName,
            value,
            minimum: minimum,
        });
};
exports.invalidStringLengthMessage = invalidStringLengthMessage;
const invalidNumberBoundsMessage = ({ functionName, propertyName, value, minimum, maximum, index }) => {
    if (minimum && maximum) {
        if (minimum === maximum) {
            return assert_1.assert.isNumber(index)
                ? messageTemplates_1.templates.error_accept_single_value_with_index({
                    functionName,
                    propertyName,
                    expectedValue: minimum,
                    value,
                    index,
                })
                : messageTemplates_1.templates.error_accept_single_value({
                    functionName,
                    propertyName,
                    expectedValue: minimum,
                    value,
                });
        }
        return assert_1.assert.isNumber(index)
            ? messageTemplates_1.templates.error_range_with_index({
                functionName,
                propertyName,
                value,
                maximum,
                minimum,
                index,
            })
            : messageTemplates_1.templates.error_range({
                functionName,
                propertyName,
                value,
                maximum,
                minimum,
            });
    }
    if (!minimum && maximum) {
        return assert_1.assert.isNumber(index)
            ? messageTemplates_1.templates.error_less_than_with_index({
                functionName,
                propertyName,
                maximum,
                value,
                index,
            })
            : messageTemplates_1.templates.error_less_than({
                functionName,
                propertyName,
                maximum,
                value,
            });
    }
    return assert_1.assert.isNumber(index)
        ? messageTemplates_1.templates.error_larger_than_with_index({
            functionName,
            propertyName,
            value,
            minimum: minimum,
            index,
        })
        : messageTemplates_1.templates.error_larger_than({
            functionName,
            propertyName,
            value,
            // TS should know that minimum can't be undefined here
            minimum: minimum,
        });
};
exports.invalidNumberBoundsMessage = invalidNumberBoundsMessage;
const invalidTypeMessage = ({ functionName, propertyName, types, value, index }) => {
    const expectedType = types
        .map(type => (type === 'nil' ? 'null' : type))
        .join(',');
    return assert_1.assert.isNumber(index)
        ? messageTemplates_1.templates.error_type_with_index({
            functionName,
            index,
            propertyName,
            value,
            expectedType,
        })
        : messageTemplates_1.templates.error_type({
            functionName,
            propertyName,
            value,
            expectedType,
        });
};
exports.invalidTypeMessage = invalidTypeMessage;
const invalidEnumValueMessage = ({ functionName, propertyName, value, enum: enumArray, index }) => {
    const expectedType = `from (${enumArray.join(',')})`;
    return assert_1.assert.isNumber(index)
        ? messageTemplates_1.templates.error_type_with_index({
            functionName,
            propertyName,
            value,
            expectedType,
            index,
        })
        : messageTemplates_1.templates.error_type({
            functionName,
            propertyName,
            value,
            expectedType,
        });
};
exports.invalidEnumValueMessage = invalidEnumValueMessage;
const patternMismatchMessage = ({ functionName, propertyName, value, index, }) => {
    return assert_1.assert.isNumber(index)
        ? messageTemplates_1.templates.error_bad_format_with_index({
            functionName,
            propertyName,
            value,
            index,
        })
        : messageTemplates_1.templates.error_bad_format({ functionName, propertyName, value });
};
exports.patternMismatchMessage = patternMismatchMessage;
const noneImageInGallery = galleryId => {
    return messageTemplates_1.templates.warning_non_images_in_gallery({
        galleryId,
    });
};
exports.noneImageInGallery = noneImageInGallery;
const invalidSlideInputMessage = ({ functionName, propertyName, slideShowId, value, minimum, maximum }) => messageTemplates_1.templates.error_slide_input({
    functionName,
    propertyName,
    slideShowId,
    value,
    maximum,
    minimum,
});
exports.invalidSlideInputMessage = invalidSlideInputMessage;
const invalidStateInputMessage = ({ functionName, propertyName, stateBoxId, value }) => messageTemplates_1.templates.error_state_input({
    functionName,
    propertyName,
    stateBoxId,
    value,
});
exports.invalidStateInputMessage = invalidStateInputMessage;
const invalidImageInGalleryWithIndex = ({ wrongValue, propertyName, index }) => {
    return messageTemplates_1.templates.error_bad_image_format_with_index({
        propertyName,
        index,
        wrongValue,
    });
};
exports.invalidImageInGalleryWithIndex = invalidImageInGalleryWithIndex;
const invalidFileTypeForFileLimit = ({ propertyName }) => {
    return messageTemplates_1.templates.error_invalid_type_for_file_limit({
        propertyName,
    });
};
exports.invalidFileTypeForFileLimit = invalidFileTypeForFileLimit;
const unsupportedLinkType = ({ functionName, wrongValue, index }) => {
    return messageTemplates_1.templates.error_supported_link_type_with_index({
        functionName,
        wrongValue,
        index,
    });
};
exports.unsupportedLinkType = unsupportedLinkType;
const invalidTargetWithIndex = ({ functionName, wrongValue, index }) => {
    return messageTemplates_1.templates.error_invalid_target_with_index({
        functionName,
        wrongValue,
        index,
    });
};
exports.invalidTargetWithIndex = invalidTargetWithIndex;
const unsupportedFunctionForType = ({ functionName, type }) => {
    return messageTemplates_1.templates.warning_unsupported_function_for_type({
        functionName,
        type,
    });
};
exports.unsupportedFunctionForType = unsupportedFunctionForType;
const invalidSvgValue = value => {
    return messageTemplates_1.templates.error_bad_svg_format({
        propertyName: 'src',
        value,
    });
};
exports.invalidSvgValue = invalidSvgValue;
const invalidMenuItemMessage = ({ propertyName, value, index, }) => {
    return assert_1.assert.isNumber(index)
        ? messageTemplates_1.templates.error_bad_menu_item_format_with_index({
            propertyName,
            value,
            index,
        })
        : messageTemplates_1.templates.error_bad_menu_item_format({
            propertyName,
            value,
        });
};
exports.invalidMenuItemMessage = invalidMenuItemMessage;
const invalidOption = ({ propertyName, wrongValue, index }) => messageTemplates_1.templates.warning_invalid_option({
    propertyName,
    wrongValue,
    index,
});
exports.invalidOption = invalidOption;
const onlyGetter = ({ propertyName, compType }) => messageTemplates_1.templates.error_only_getter({
    propertyName,
    compType,
});
exports.onlyGetter = onlyGetter;
const invalidFormatMessageWithHint = ({ propertyName, functionName, wrongValue, hint }) => {
    return messageTemplates_1.templates.error_bad_format_with_hint({
        propertyName,
        functionName,
        wrongValue,
        hint,
    });
};
exports.invalidFormatMessageWithHint = invalidFormatMessageWithHint;
const invalidObjectFormatWithCustomMessage = ({ keyName, propertyName, functionName, wrongValue, message }) => {
    return messageTemplates_1.templates.error_object_bad_format({
        keyName,
        propertyName,
        functionName,
        wrongValue,
        message,
    });
};
exports.invalidObjectFormatWithCustomMessage = invalidObjectFormatWithCustomMessage;
const invalidOptionFields = ({ propertyName, wrongValue, fields, index }) => messageTemplates_1.templates.error_invalid_option_fields({
    propertyName,
    wrongValue,
    fields,
    index,
});
exports.invalidOptionFields = invalidOptionFields;
const invalidItemLink = ({ functionName, propertyName, index }) => messageTemplates_1.templates.error_item_external_link({
    propertyName,
    functionName,
    index,
});
exports.invalidItemLink = invalidItemLink;
const unsupportedPropertyMessageWithHint = ({ propertyName, hint }) => messageTemplates_1.templates.error_unsupported_property_with_hint({
    propertyName,
    hint,
});
exports.unsupportedPropertyMessageWithHint = unsupportedPropertyMessageWithHint;
const nonExistingItem = ({ functionName, propertyName, value }) => messageTemplates_1.templates.error_item_not_found({
    propertyName,
    functionName,
    value,
});
exports.nonExistingItem = nonExistingItem;
const invalidArrayLength = ({ functionName, propertyName, value, arrayLength }) => messageTemplates_1.templates.error_array_length({
    propertyName,
    functionName,
    value,
    arrayLength,
});
exports.invalidArrayLength = invalidArrayLength;
//# sourceMappingURL=messages.js.map